/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobEngineTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyJobEngineTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyJobEngineTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobEngineTypeQueryOperator>): PolicyJobEngineTypeQueryOperator {
        let obj = Object.assign(new PolicyJobEngineTypeQueryOperator(), model);
        PolicyJobEngineTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobEngineTypeQueryOperator>): PolicyJobEngineTypeQueryOperator {
        if (!model) return null;
        return PolicyJobEngineTypeQueryOperator.newInstance(<PolicyJobEngineTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobEngineTypeQueryOperator) {
        if (!obj) return;

        models.PolicyJobEngineTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobEngineTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyJobEngineTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy engine types to include
     */
    engine_types: Array<models.PolicyEngineType>;

}
